import React, { Component } from 'react';
// Icons collection
import 'material-design-icons/iconfont/material-icons.css';
import { MoThemeProvider } from '@movember/mo-gel';

import { MenLikeMePage } from './pages/MenLikeMe';
import CookieConsent from './components/Cookies/CookieConsent';
import { Header } from './components-global';
import { TrueNorthLight } from './themes';
import { RootStyle } from './App.styled';

export class App extends Component {
  static setDataLayerSnippet(w, d, s, l, i) {
    w[l] = w[l] || []; // eslint-disable-line no-param-reassign
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? `&l=${l}` : '';
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}&gtm_auth=UTDUUsLnIJzXkXQQsAF15w&gtm_preview=env-56&gtm_cookies_win=x`;
    f.parentNode.insertBefore(j, f);
  }

  static gaSnippet() {
    App.setDataLayerSnippet(window, document, 'script', 'dataLayer', process.env.REACT_APP_GTM_ID);
  }

  constructor(props) {
    super(props);

    this.state = {
      isBlurred: false
    };
  }

  render() {
    const { isBlurred } = this.state;
    return (
      <MoThemeProvider theme={TrueNorthLight} className="App">
        <>
          <RootStyle isBlurred={isBlurred} />
          <CookieConsent gaSnippet={App.gaSnippet} />
          <Header language="en-gb" onBlur={(event) => this.setState({ isBlurred: event })} />
          <MenLikeMePage isBlurred={isBlurred} onThemeChanged={() => this.forceUpdate()} />
        </>
      </MoThemeProvider>
    );
  }
}

export default App;
